import * as Sentry from '@sentry/react'
import type { LogoutReason } from './authTypes'

export type AuthLogoutSource =
	| 'http_response_interceptor'
	| 'http_error_interceptor'
	| 'websocket_connect_error'

export function reportAuthLogout(
	reason: LogoutReason,
	source: AuthLogoutSource,
	extra?: Record<string, unknown>
) {
	const payload = {
		reason,
		source,
		path: window.location.pathname,
		...extra,
	}

	Sentry.addBreadcrumb({
		category: 'auth',
		message: `Forced logout: ${reason}`,
		level: 'warning',
		data: payload,
	})

	Sentry.captureMessage(`Auth forced logout: ${reason}`, {
		level: 'warning',
		tags: {
			auth_logout_reason: reason,
			auth_logout_source: source,
		},
		extra: payload,
	})
}
